import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, OnChanges, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DadosPessoaisAba1Response } from 'app/auth/_models/DadosPessoaisAba1';
import { ToastrService } from 'ngx-toastr';
import { DadosExcecoesService } from '../../service/dados-excecoes/dados-excecoes.service';
import { Enum } from 'app/model/enum';
import { forkJoin, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatTableDataSource } from '@angular/material/table';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { PageEvent } from '@angular/material/paginator';
import { DatePipe } from '@angular/common';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import * as moment from 'moment';
import { ServidorService } from "../../service/servidor/servidor.service";
export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY'
  },
};


@Component({
  selector: 'app-excecoes',
  templateUrl: './excecoes.component.html',
  styleUrls: ['./excecoes.component.sass'],
  providers: [
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: ['l', 'LL'],
        },
        display: {
          dateInput: 'L',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MMMM YYYY',
        },
      },
    }
  ]
})

export class ExcecoesComponent implements OnInit, OnChanges {
  @Input() mostrarAlerta: any;
  @Output() voltarPagina: EventEmitter<void> = new EventEmitter<void>();
  // @Output() dadosSalvos: EventEmitter<void> = new EventEmitter<void>();
  //@Output() formularioSalvo = new EventEmitter<void>();
  @ViewChild('pickerDataInicio') pickerDataInicio: MatDatepicker<Date>;
  @ViewChild('pickerDataFim') pickerDataFim: MatDatepicker<Date>;
  @ViewChild(MatAutocompleteTrigger) autoTrigger: MatAutocompleteTrigger;
  @ViewChild('textarea', { static: true }) textarea: ElementRef<HTMLDivElement>;
  form: FormGroup;
  user: DadosPessoaisAba1Response = null;
  isLoadingSpinner: boolean = true;
  dataInicio: Date;
  dataFim: Date;
  minData: Date;

  matricula: number;
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  displayedColumns: string[] = ['matricula', 'id', 'tipoCampanha', 'ano'];
  public servidorDigitado: string;
  public options: any[] = [];
  public filteredOptions: any[] = [];

  pageIndex = 0;
  pageSize: number = 5;
  texto: string = '';
  caracteresRestantes: number = 2000;
  limiteAtingido: boolean = false;
  anos: number[] = [];
  dataSourceModal: any[];
  totalElements: number;
  linhasTransportes: Enum[];
  pageNumber: number = 0;
  filterValue: string = '';

  constructor(
    // private dadosPessoaisAba1: DadosPessoaisAba1,
    private toasterService: ToastrService,
    private formBuilder: FormBuilder,
    private exececoesService: DadosExcecoesService,
    private datePipe: DatePipe,
    private servidorService: ServidorService
  ) {
    this.user = JSON.parse(sessionStorage.getItem('SessionDataUserAuth'));

  }

  ngOnInit(): void {
    this.createForm();
    this.user = JSON.parse(sessionStorage.getItem('SessionDataUserAuth'));
    this.processarExcecoes();
    this.form.get('tipoCampanha').valueChanges.subscribe((valorSelecionado) => {
      if (valorSelecionado != null && valorSelecionado != '') this.tipoCampanha(valorSelecionado)
    });
  }

  formatarData(data: string): string {
    const dataObj = new Date(data);
    const dia = dataObj.getDate().toString().padStart(2, '0');
    const mes = (dataObj.getMonth() + 1).toString().padStart(2, '0');
    const ano = dataObj.getFullYear();

    return `${dia}/${mes}/${ano}`;
  }

  private processarExcecoes(): void {
    const pagina = this.pageNumber; // pageIndex é baseado em zero, então adicionamos 1
    const tamanho = this.pageSize;
    // todasExcecoesCadastradas$: Observable<Enum[]> = this.getExcecao('', pagina, tamanho);
    const todasExcecoesCadastradas$: Observable<Enum[]> = this.getExcecao('', pagina, tamanho);

    forkJoin([todasExcecoesCadastradas$])
      .pipe(finalize(() => this.isLoadingSpinner = false))
      .subscribe(
        ([todasExcecoesCadastradas]) => {
          this.atualizarFormulario(todasExcecoesCadastradas);

        },
        (error) => {
          //this.mostrarMensagem('Ocorreu um erro ao carregar os dados. Por favor, tente novamente.');
        }
      );
  }

  tipoCampanha(tipoCampanha) {
    this.getAnosDisponiveisCampanha(tipoCampanha).subscribe(
      (response) => {
        this.anos = response;
      },
      (error) => {
        console.error(error);
      }
    );
  }
  private getExcecoesCadastradas(pagina, tamanho, filtro): Observable<any> {
    return this.exececoesService.getExcecao(pagina, tamanho, filtro)
  }
  onPageChange(event: PageEvent) {
    this.pageNumber = event.pageIndex;
    this.pageSize = event.pageSize;
    this.getExcecoesCadastradas(this.filterValue, this.pageNumber, this.pageSize).subscribe(response => {
      this.linhasTransportes = response.content;
      this.dataSourceModal = this.linhasTransportes
      this.totalElements = response.totalElements;
    });
  }
  applyFilter(value: string) {
    const começaComNúmero = /^\d/.test(value);

    if (começaComNúmero == false) {
      const formattedValue = value.trim().toLowerCase();
      this.filterValue = formattedValue.toUpperCase()
    } else this.filterValue = value

    const todasLinhasTransporte$: Observable<Enum[]> = this.getExcecao(this.filterValue, 0, this.pageSize,);

    forkJoin([todasLinhasTransporte$])
      .pipe(finalize(() => this.isLoadingSpinner = false))
      .subscribe(
        ([todasLinhasTransporte]) => {
          this.atualizarLinhasComFiltro(todasLinhasTransporte);

        },
        (error) => {
          //this.mostrarMensagem('Ocorreu um erro ao carregar os dados. Por favor, tente novamente.');
        }
      );
  }
  private atualizarLinhasComFiltro(todasLinhasTransporte) {
    this.linhasTransportes = todasLinhasTransporte['content'];
    this.dataSourceModal = this.linhasTransportes
    this.totalElements = todasLinhasTransporte['totalElements'];
  }

  public onInputChange(): void {
    const value = this.form.value.matricula;
    const começaComNúmero = /^\d/.test(value);
    if (value) {
      this.servidorDigitado = value;
      this.getServidor(this.servidorDigitado).subscribe(
        (response) => {
          this.options = response.content;

          if (começaComNúmero == false) {
            this.filteredOptions = this.options.filter((option) =>
              option.nome.toLowerCase().includes(value.toLowerCase())
            );
          } else {
            this.filteredOptions = this.options.filter((option) =>
              option.matricula);
          }
          this.autoTrigger.openPanel(); // Abre o painel do mat-autocomplete
        },
        (error) => {
          console.error(error);
        }
      );
    } else {
      this.options = [];
      this.filteredOptions = [];
    }
  }
  public onInputChangeExcecao(): void {
    const value = this.form.value.matricula;

    if (value) {
      this.servidorDigitado = value;
      this.getServidor(this.servidorDigitado).subscribe(
        (response) => {
          this.options = response.content;
          this.filteredOptions = this.options.filter((option) =>
            option.nome.toLowerCase().includes(value.toLowerCase())
          );
          this.autoTrigger.openPanel(); // Abre o painel do mat-autocomplete
        },
        (error) => {
          console.error(error);
        }
      );
    } else {
      this.options = [];
      this.filteredOptions = [];
    }
  }
  public onOptionSelected(option: any): void {
    this.matricula = option.matricula;
  }

  private getAnosDisponiveisCampanha(tipoCampanha): Observable<any> {
    return this.exececoesService.getAnosDisponiveisCampanha(tipoCampanha);
  }

  private getExcecao(filtro, pagina, tamanho,): Observable<any> {
    return this.exececoesService.getExcecao(filtro, pagina, tamanho);
  }

  private getServidor(dadosServidor): Observable<any> {
    return this.servidorService.getServidor(dadosServidor);
  }

  calcularDataFim(): void {

    this.dataInicio = this.form.value.dataInicio;
    this.dataFim = this.form.value.dataFim;
    this.verificarPeridoSemReturn()
    if (this.dataInicio) {
      const dataLimite = new Date(this.dataInicio);
      const dataMinima = new Date(this.dataInicio);

      if (this.form.value.tipoCampanha == 1) {
        dataMinima.setDate(dataMinima.getDate() - 0);

        dataLimite.setDate(dataLimite.getDate() + 9);
        this.dataFim = dataLimite;
        this.minData = dataMinima;
      }
      if (this.form.value.tipoCampanha == 2) {
        dataMinima.setDate(dataMinima.getDate() - 0);

        dataLimite.setDate(dataLimite.getDate() + 14);
        this.dataFim = dataLimite;
        this.minData = dataMinima;
      }

    }
  }

  verificarDataFim() {

    if (moment(this.form.value.dataFim).toDate().getTime() < moment(this.form.value.dataInicio).toDate().getTime()) {
      this.form.patchValue({ dataFim: null });
      this.toasterService.warning('A data de início deve ser anterior à data fim!');
      return true
    }
  }
  verificarPeridoSemReturn() {
    if (this.verificarDataFim()) return
    const umDiaEmMilissegundos = 24 * 60 * 60 * 1000; // Valor em milissegundos para um dia

    const dataInicio = new Date(this.form.value.dataInicio);
    const dataFim = new Date(this.form.value.dataFim);
    const dataAtual = new Date(); // Obtendo a data atual

    const diffEmDias = Math.round(Math.abs((dataFim.getTime() - dataInicio.getTime()) / umDiaEmMilissegundos));
    dataInicio.setHours(0,0,0,0); // Define as horas para 00:00:00
    dataAtual.setHours(0,0,0,0); // Define as horas para 00:00:00

    if (dataInicio < dataAtual) {
        this.toasterService.warning('Data início inválida!');
        this.form.controls.dataInicio.reset()
        return false;
    }

    if (diffEmDias > 9 && this.form.value.tipoCampanha == 1 && this.dataInicio != null && this.dataFim != null) {
      this.toasterService.warning('O Período de Recadastramento para exceções é de 10 dias.');
      this.form.controls.dataFim.reset()
      return false
    }
    if (diffEmDias > 14 && this.form.value.tipoCampanha == 2 && this.dataInicio != null && this.dataFim != null) {
      this.toasterService.warning('O Período máximo de Bens e Valores para exceções é de 15 dias.');
      this.form.controls.dataFim.reset()
      return false

    }
    return true
  }

  atualizarContagem() {
    const maxCaracteres = 2000;
    const justificativa = this.form.get('justificativa').value;
    this.caracteresRestantes = maxCaracteres - justificativa.length;

    if (this.caracteresRestantes < 0) {
      this.form.get('justificativa').setValue(justificativa.slice(0, maxCaracteres));
      this.caracteresRestantes = 0;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // if (changes.mostrarAlerta) {
    //   this.isInfoImportantVisible = true
    // }
  }

  // toggleInfoImportantVisible() {
  //   this.isInfoImportantVisible = !this.isInfoImportantVisible;
  // }


  private atualizarFormulario(todasExcecoesCadastradas: Enum[]): void {
    this.dataSource = todasExcecoesCadastradas['content'];
    this.dataSourceModal = todasExcecoesCadastradas['content'];
    this.totalElements = todasExcecoesCadastradas['totalElements'];
    this.linhasTransportes = todasExcecoesCadastradas

    this.form.patchValue({
      // numeroLogradouro: endereco.numeroLogradouro,
      // descComplementoLogradouro: endereco.descComplementoLogradouro,
      // descBairro: endereco.descBairro,
      // numeroCepLogradouro: endereco.numeroCepLogradouro,
      // descricaoMunicipioLogradouro: endereco.descricaoMunicipioLogradouro,
      // codUfLogradouro: endereco.codUfLogradouro,
      // codTipoLogradouro: endereco.codTipoLogradouro.trim(),
    });
  }

  limparFormCamposAoAdicionarExcececoes() {
    // this.form.controls.tipoCampanha.clearValidators();
    // this.form.controls.tipoCampanha.reset();

    // this.form.controls.ano.clearValidators();
    // this.form.controls.ano.reset();

    // this.form.controls.dataInicio.clearValidators();
    // this.form.controls.dataInicio.reset();

    // this.form.controls.dataFim.clearValidators();
    // this.form.controls.dataFim.reset();

    // this.form.controls.justificativa.clearValidators();
    // this.form.controls.justificativa.reset();

    this.form.controls.matricula.clearValidators();
    this.form.controls.matricula.reset();
    this.matricula = null
  }

  createForm() {
    this.form = this.formBuilder.group({
      tipoCampanha: ['', [Validators.required]],
      ano: ['', [Validators.required]],
      dataInicio: ['', [Validators.required]],
      dataFim: ['', [Validators.required]],
      justificativa: ['', [Validators.required]],
      matricula: ['', [Validators.required]],
    });
  }

  limparNomeOuMatricula() {
    this.form.controls.matricula.reset();
    this.matricula = null
  }

  adicionarValidadoresAosCampos() {
    // Adicione os validadores necessários para cada campo
    this.form.controls.tipoCampanha.setValidators([Validators.required]);
    this.form.controls.ano.setValidators([Validators.required]);
    this.form.controls.dataInicio.setValidators([Validators.required]);
    this.form.controls.dataFim.setValidators([Validators.required]);
    this.form.controls.justificativa.setValidators([Validators.required]);
    this.form.controls.matricula.setValidators([Validators.required]);

    // Atualize o estado de validação dos campos
    this.form.controls.tipoCampanha.updateValueAndValidity();
    this.form.controls.ano.updateValueAndValidity();
    this.form.controls.dataInicio.updateValueAndValidity();
    this.form.controls.dataFim.updateValueAndValidity();
    this.form.controls.justificativa.updateValueAndValidity();
    this.form.controls.matricula.updateValueAndValidity();
  }

  adicionarExcecao() {
    this.adicionarValidadoresAosCampos()
    const body = {
      tipoCampanha: this.form.value.tipoCampanha,
      ano: this.form.value.ano,
      dataInicio: this.form.value.dataInicio,
      dataFim: this.form.value.dataFim,
      justificativa: this.form.value.justificativa,
      matricula: this.matricula,
    };
    if (!this.verificarPeridoSemReturn()) {
      return
    }
    if (this.form.valid) {
      //Lógica para enviar os dados do formulário
      this.exececoesService.adicionarExcecao(body).subscribe(
        (response) => {
          this.toasterService.success('Dados atualizados com sucesso');
          this.limparFormCamposAoAdicionarExcececoes()
          this.processarExcecoes()
        },
        (error) => {
          if (error.status == 422) {
            this.toasterService.error('Já existe uma exceção registrada para esse período.');
          } else {
            this.toasterService.error('Ocorreu um erro ao adicionar uma exceção.');
          }
        }
      );
    } else {
      this.toasterService.warning('Atenção: Todos os campos marcados com (*) são obrigatórios!');
    }

  }

  voltarPaginaAnterior() {
    this.voltarPagina.emit()
  }

}

